import { AppConstants } from '../app.constants';

export class ResultFilterModel {
  private _currentView: string;
  private _cgicCode: string;

  constructor(cgicCode: string, view: string) {
    this._currentView = view;
    this._cgicCode = cgicCode;
  }

  get defaultFilterDateDurationDays(): number {
    return AppConstants.filterDateDurationDays;
  }

  get currentView(): string {
    return this._currentView;
  }

  set currentView(view: string) {
    this._currentView = view;
  }

  get cgicCode(): string {
    return this._cgicCode;
  }

  set cgicCode(code: string) {
    this._cgicCode = code;
  }
}
